<template>
  <div class="login-wrapper">
    <div class="login-container" v-if="!isLoading">
      <div class="back-btn-text" @click="backBtn">Kembali</div>
      <div class="logo">
        <img src="@/assets/logo/icon_rk_new.webp" alt="Logo RUMATKITA" />
      </div>
      <h2>Masuk atau Daftar</h2>
      <form @submit.prevent="submitForm">
        <input type="text" v-model="phoneNumber" placeholder="Masukkan Nomor Whatsapp" inputmode="numeric" />
        <button type="submit" @click.prevent="generateOtp">{{ otpProcessingText }}</button>
      </form>
      <p>
        Dengan masuk atau mendaftar, Anda menyetujui
        <a href="#">Syarat & Ketentuan</a> dan <a href="#">Kebijakan Privasi</a> RUMATKITA.
      </p>
    </div>
    <div v-if="isBottomSheetOpen && !isLoading" class="bottom-sheet-overlay">
      <div class="bottom-sheet-content">
        <div class="bottom-sheet-header">
          <h5 class="bottom-sheet-title">Verifikasi kode OTP</h5>
        </div>
        <div class="bottom-sheet-body">
          <p>Masukan kode OTP yang telah terkirim ke nomor Whatsapp :</p>
          <p>{{ phoneNumber }}</p>
          <div class="otp-inputs">
            <input
              v-for="(otp, index) in otpInputs"
              :key="index"
              v-model="otpInputs[index]"
              type="text"
              maxlength="1"
              @input="handleOtpInput($event, index)"
              :class="{ error: isOtpError }"
              ref="otpInputs"
              inputmode="numeric"
              pattern="[0-9]*"
            />
          </div>
          <p v-if="isOtpError" class="error-message">{{ errMsg }}</p>

          <p v-if="showResendButton">
            <span>Belum mendapatkan kode?</span>
            <a href="#" @click.prevent="resendOtp">
              Kirim kode baru
            </a>
          </p>

        </div>
      </div>
    </div>

    <alert-popup :alertData="alertData" @closeAlert="closeAlert"></alert-popup>
  </div>
</template>

<script>
import axios from "axios";
import storage from "@/controllers/storage";
import AlertPopup from "@/components/AlertPopup.vue";
import userController from "@/controllers/user";
import { setAnalyticsUser } from "@/utils/analytics";

export default {
  name: "login-view",
  data() {
    return {
      isProcessing: false,
      phoneNumber: "",
      isBottomSheetOpen: false,
      otpInputs: ["", "", "", ""],
      isOtpError: false,
      errMsg: "",
      isLoading: false,

      deviceInfo: {
        browser: "",
        os: "",
        platform: "",
        ip: "",
      },

      // Resend control
      showResendButton: false,
      resendTimer: null,

      //Alert
      alertData: {
        alertShow: false,
        alertTitle: "",
        alertMessage: "",
      },
    };
  },

  components: {
    AlertPopup,
  },

  methods: {
    normalizePhoneNumber(input) {
      return input.replace(/\D/g, "");
    },

    async closeAlert() {
      this.alertData.alertShow = false;
    },

    async generateOtp() {
      if (this.isProcessing) return;

      this.isProcessing = true;
      await this.getDeviceInfo();

      try {
        const device_id = `${this.deviceInfo.browser}|${this.deviceInfo.os}|${this.deviceInfo.platform}|${this.deviceInfo.ip}`;
        const response = await userController.generateOtp(
          this.normalizePhoneNumber(this.phoneNumber),
          device_id
        );

        if (response.data.status == 200) {
          this.openBottomSheet();
          this.startResendTimer(); // 🔥 mulai timer 60 detik
        } else {
          this.alertData.alertShow = true;
          this.alertData.alertTitle = "Peringatan";
          this.alertData.alertMessage = response.data.message;
        }
      } catch (error) {
        console.error("Error generating OTP:", error);
      }

      this.isProcessing = false;
    },

    async verifyOtp() {
      await this.getDeviceInfo();

      try {
        const device_id = `${this.deviceInfo.browser}|${this.deviceInfo.os}|${this.deviceInfo.platform}|${this.deviceInfo.ip}`;
        const response = await userController.receiveOtp(
          this.normalizePhoneNumber(this.phoneNumber),
          device_id,
          this.otpInputs.join("")
        );

        if (response.data.status == 200) {
          if (response.data.user_status == 1) {
            const datarequest = {
              token: response.data.access_token,
              memberId: response.data.user_code,
            };
            storage.setLocalStorage(datarequest);
            setAnalyticsUser(response.data.user_code);
            this.$router.push({ name: "HomeView" });
          } else {
            this.$router.push({ name: "register-view" });
          }
        } else {
          this.isOtpError = true;
          this.errMsg = response.data.message;
        }
      } catch (error) {
        this.isOtpError = true;
        this.errMsg = "Kode tidak valid. Silakan periksa kembali.";
      }
    },

    openBottomSheet() {
      this.isBottomSheetOpen = true;
    },

    handleOtpInput(event, index) {
      const value = event.target.value;

      if (value.length === 1) {
        if (index < this.otpInputs.length - 1) {
          this.$refs.otpInputs[index + 1].focus();
        } else {
          this.verifyOtp();
        }
      } else if (value.length === 0 && index > 0) {
        this.$refs.otpInputs[index - 1].focus();
      }
    },

    startResendTimer() {
      this.showResendButton = false;

      if (this.resendTimer) {
        clearTimeout(this.resendTimer);
      }

      // ⏳ 60 detik, sama dengan jeda kirim ulang di server (config/otp.php
      // resend_cooldown_seconds). Kalau lebih pendek, server menolak dengan 429.
      this.resendTimer = setTimeout(() => {
        this.showResendButton = true;
      }, 60000);
    },

    async resendOtp() {
      this.isOtpError = false;
      await this.generateOtp();
    },

    async getDeviceInfo() {
      this.deviceInfo.browser = navigator.userAgent;
      this.deviceInfo.os = this.getOS();
      this.deviceInfo.platform = navigator.platform;
      this.deviceInfo.ip = await this.getIP();
    },

    getOS() {
      const userAgent = navigator.userAgent;

      if (userAgent.indexOf("Win") !== -1) return "Windows";
      if (userAgent.indexOf("Mac") !== -1) return "MacOS";
      if (userAgent.indexOf("Linux") !== -1) return "Linux";
      if (userAgent.indexOf("Android") !== -1) return "Android";
      if (userAgent.indexOf("iOS") !== -1) return "iOS";

      return "";
    },

    async getIP() {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        return response.data.ip;
      } catch {
        return "Unknown";
      }
    },

    async backBtn() {
      this.$router.go(-1);
    },
  },

  async mounted() {
    const session = storage.getLocalStorage();

    if (session.token) {
      this.$router.push({ name: "HomeView" });
    }
  },

  computed: {
    otpProcessingText() {
      return this.isProcessing ? "Memproses..." : "Lanjut";
    },
  },
};
</script>


<style scoped>
@import url("./css/login.css");
</style>
